import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../shared/my-constants';

@Injectable()
export class DoctorDetailsService {
    trnOtStaffDetails: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'trn_ot_doctor_details/list/?';
    private AddRecord = webapi + 'trn_ot_doctor_details/create';
    private AddListRecord = webapi + 'trn_ot_doctor_details/createbylistbyopsid/';
    private UpdateListRecord = webapi + 'trn_ot_doctor_details/updatebylistbyopdid/';
    private EditRecord = webapi + 'trn_ot_doctor_details/update';
    private GetRecord = webapi + 'trn_ot_doctor_details/byid/';
    private DeleteRecord = webapi + 'trn_ot_doctor_details/delete/';
    private GetRecordByOpsId = webapi + 'trn_ot_doctor_details/byopsid/';
    private GetRecordByOpdId = webapi + 'trn_ot_doctor_details/byopdid/';

    constructor( private http: Http ) { }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordListService(opsId, model: any) {
        return this.http.post(this.AddListRecord + opsId, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateByOpdIdRecordListService(model: any) {
        return this.http.post(this.UpdateListRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordByOpsIdService(opsId) {
        return this.http.get(this.GetRecordByOpsId + opsId )
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordByOpdIdService(opsId) {
        return this.http.get(this.GetRecordByOpdId + opsId )
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/operation-theater/ot-schedule/doctor-details/doctor-details.service.ts